"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRouterProvider = void 0;
const React = require("react");
const react_router_last_location_1 = require("react-router-last-location");
const history_1 = require("history");
const react_router_1 = require("react-router");
const BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
class ClientRouterProvider extends BaseProvider_1.BaseProvider {
    constructor() {
        super((0, history_1.createBrowserHistory)());
    }
    component(children) {
        const RouterComponent = react_router_1.Router;
        return (React.createElement(RouterComponent, { history: this.provider },
            React.createElement(react_router_last_location_1.LastLocationProvider, null, children)));
    }
}
exports.ClientRouterProvider = ClientRouterProvider;
//# sourceMappingURL=ClientRouterProvider.js.map